import { Trans } from "@lingui/react/macro";
import { cloneDeep } from "lodash";
import { observable } from "mobx";
import { useState } from "react";

import { Button } from "../../../components/ui-kit/button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { createPatch } from "../../../utils/patch";
import { AdminConsole } from "../admin-console";
import { QuestionnaireSettingsItem } from "./questionnaire-settings";
import { QuestionnaireSettingsForm } from "./questionnaire-settings-form";

export function EditQuestionnaireSettingsDialog({
  item,
  admin,
  onClose,
  onSave,
}: {
  item: QuestionnaireSettingsItem;
  admin: AdminConsole;
  onClose: () => void;
  onSave: (patch: Record<string, unknown>) => Promise<void>;
}) {
  const [fields] = useState(() =>
    observable({
      first_when_active: item.first_when_active,
      skippable: item.skippable ?? false,
      filling_frequency: cloneDeep(item.filling_frequency ?? []),
      first_after_active: cloneDeep(item.first_after_active) ?? null,
      stop_after_n: item.stop_after_n ?? null,
      stop_after_time_from_first:
        cloneDeep(item.stop_after_time_from_first) ?? null,
    }),
  );

  async function save() {
    const body = createPatch(fields, item);
    if (Object.keys(body).length === 0) {
      onClose();
      return;
    }
    await onSave(body);
    onClose();
  }

  return (
    <Dialog open onOpenChange={() => onClose()} width="672px">
      <h3 className="mb-6 text-base font-bold">
        <Trans>Edit questionnaire settings</Trans>
      </h3>
      <div className="overflow-y-auto min-h-0 px-1 py-1">
        <QuestionnaireSettingsForm fields={fields} admin={admin} mode="edit" />
      </div>
      <div className="mt-6 flex justify-center gap-2">
        <Button onClick={() => save()}>
          <Trans>Save</Trans>
        </Button>
        <Button variant="subtle" size="default" onClick={onClose}>
          <Trans>Cancel</Trans>
        </Button>
      </div>
    </Dialog>
  );
}
